import type { Metrics } from '@libs/utils';
import { buildMetrics, log } from '@libs/utils';

let metrics: Metrics;

export function getMetrics(): Metrics {
  if (!metrics) {
    metrics = buildMetrics(
      'trip_planner',
      'https://metrics-gateway.sembo.com/input',
      (error) => {
        log({ title: 'Metrics', context: ['Error', { error }] });
      }
    );
  }

  return metrics;
}
